<template>
  <footer class="footer-sponsor" v-if="banner != null && banner != ''">
    <img :src="getUrlBanner()" alt="Banner">
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      banner: state => state.InfoModule.banner
    })
  },
  async mounted() {
    if (this.banner == null) await this.$store.dispatch('getBanner')
  },
  methods: {
    getUrlBanner() {
      return `${process.env.VUE_APP_CDN_URL_BANNERS}${this.banner}`
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.footer-sponsor {
  height: 50px;
  width: 100%;
  position: fixed;
  @include font-settings(xmilli, base);
  font-weight: 700;
  bottom: 0;
  background: $darkblue;
  color: $white;
  display: flex;
  z-index: 3;
  justify-content: center;
  padding: 0;
  align-items: center;

  img {
    width: 320px;
    height: 50px;
  }

  strong {
    padding: $margin-milli 0;
  }
}
</style>